var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjectInActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 20,
    viewBox: "0 0 27 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M5.82324 11.2257H13.5101L10.3711 5.9112C10.299 5.78839 10.1961 5.68656 10.0725 5.6158C9.94899 5.54504 9.80907 5.50781 9.66669 5.50781C9.5243 5.50781 9.38439 5.54504 9.26084 5.6158C9.13728 5.68656 9.03437 5.78839 8.96231 5.9112L5.82324 11.2257Z",
    fill: "#2B5B7F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M17.425 5.50913C18.5526 5.50913 19.4666 4.59504 19.4666 3.46745C19.4666 2.33987 18.5526 1.42578 17.425 1.42578C16.2974 1.42578 15.3833 2.33987 15.3833 3.46745C15.3833 4.59504 16.2974 5.50913 17.425 5.50913Z",
    fill: "#2B5B7F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M15.6499 14.8725L19.0248 9.17727C19.0971 9.05541 19.1999 8.95445 19.323 8.88433C19.4462 8.81422 19.5854 8.77734 19.7271 8.77734C19.8688 8.77734 20.0081 8.81422 20.1312 8.88433C20.2544 8.95445 20.3571 9.05541 20.4295 9.17727L26.0002 18.5771H17.8335L15.6499 14.8725Z",
    fill: "#2B5B7F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.425 5.50913C18.5526 5.50913 19.4666 4.59504 19.4666 3.46745C19.4666 2.33987 18.5526 1.42578 17.425 1.42578C16.2974 1.42578 15.3833 2.33987 15.3833 3.46745C15.3833 4.59504 16.2974 5.50913 17.425 5.50913Z",
    stroke: "#A9B9C6",
    strokeWidth: 1.63334,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 18.5757L8.96231 5.9112C9.03437 5.78839 9.13728 5.68656 9.26083 5.6158C9.38439 5.54504 9.5243 5.50781 9.66669 5.50781C9.80907 5.50781 9.94898 5.54504 10.0725 5.6158C10.1961 5.68656 10.299 5.78839 10.3711 5.9112L17.8334 18.5757H1.5Z",
    stroke: "#A9B9C6",
    strokeWidth: 1.63334,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.82324 11.2266H13.5101",
    stroke: "#A9B9C6",
    strokeWidth: 1.63334,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6499 14.8725L19.0248 9.17727C19.0971 9.05541 19.1999 8.95445 19.323 8.88433C19.4462 8.81422 19.5854 8.77734 19.7271 8.77734C19.8688 8.77734 20.0081 8.81422 20.1312 8.88433C20.2544 8.95445 20.3571 9.05541 20.4295 9.17727L26.0002 18.5771H17.8335",
    stroke: "#A9B9C6",
    strokeWidth: 1.63334,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectInActive);
export default __webpack_public_path__ + "static/media/ProjectInActive.62c02106cf85d39e621204d1f3712046.svg";
export { ForwardRef as ReactComponent };